import React from 'react';
import buttonStyles from '../../../../../../styles/Buttons.module.css';
import styles from '../../../../../../styles/UserManagementTab.module.css';

interface SelectionBannerProps {
  selectedCount: number;
  totalCount: number;
  onSelectAll: () => void;
  onClearSelection: () => void;
  onBulkAction: (action: 'remove' | 'change_role') => void;
  canManageUsers: boolean;
}

const SelectionBanner: React.FC<SelectionBannerProps> = ({
  selectedCount,
  totalCount,
  onSelectAll,
  onClearSelection,
  onBulkAction,
  canManageUsers
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className={styles.selectionBanner}>
      <div className={styles.selectionBannerContent}>
        <span className={styles.selectionText}>
          Selected <strong>{selectedCount}</strong> user{selectedCount !== 1 ? 's' : ''}.
        </span>
        <div className={styles.selectionActions}>
          {canManageUsers && (
            <>
              <button 
                className={`${buttonStyles.btn} ${buttonStyles.btnPrimary} ${styles.compactBtn}`}
                onClick={() => onBulkAction('change_role')}
                title="Change Role"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                </svg>
                <span className={styles.btnText}>Change Role</span>
              </button>
              <button 
                className={`${buttonStyles.btn} ${buttonStyles.btnDanger} ${styles.compactBtn}`}
                onClick={() => onBulkAction('remove')}
                title="Remove from Group"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="3,6 5,6 21,6"></polyline>
                  <path d="M19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path>
                  <line x1="10" y1="11" x2="10" y2="17"></line>
                  <line x1="14" y1="11" x2="14" y2="17"></line>
                </svg>
                <span className={styles.btnText}>Remove from Group</span>
              </button>
            </>
          )}
          <button 
            className={`${buttonStyles.btn} ${buttonStyles.btnSecondary} ${styles.compactBtn}`}
            onClick={onClearSelection}
            title="Clear selection"
          >
            
            <span className={styles.btnText}>Clear</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectionBanner;

